<template>
  <div class="app-container">
    <transition name="el-zoom-in-top">
      <div v-show="!showAdd" class="filter-container">
        <el-button v-waves class="filter-item" type="info" icon="el-icon-back" @click="back">{{ $t('table.back') }}</el-button>
        <el-input :placeholder="`用户名称`" v-model="listQuery.name" style="width: 200px;" class="filter-item" @keyup.enter.native="handleFilter"/>
        <!-- <el-select v-model="listQuery.roleId" :placeholder="$t('table.role')" clearable class="filter-item" style="width: 130px">
          <el-option v-for="item in roleList" :key="item.RoleId" :label="item.RoleName" :value="item.RoleId"/>
        </el-select> -->
        <el-button v-waves class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter">{{ $t('table.search') }}</el-button>
        <!-- <el-button v-if="calcPermission(permition, 1)" class="filter-item" style="float:right" type="primary" icon="el-icon-edit" @click="addField()">{{ $t('table.add') }}</el-button> -->
      </div>
    </transition>
    <transition name="el-zoom-in-top">
      <div v-show="!showAdd" class="filter-container">
        <el-table
          v-loading="listLoading"
          :key="list.id"
          :data="list"

          fit
          stripe
          highlight-current-row
          style="width: 100%;">
          <el-table-column :label="$t('table.id')" align="center">
            <template slot-scope="scope">
              <span>{{ (scope.$index + 1) + ((listQuery.pageIndex - 1) * listQuery.pageSize) }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('table.name')" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.UserName }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('table.telPhone')" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.TelPhone">{{ scope.row.TelPhone }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('table.actions')" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.SexNo">{{ scope.row.SexNo === 'M' ? '男' : '女' }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('table.sex')" align="center">
            <template slot-scope="scope">
              <el-button v-if="calcPermission(permition, 6)" size="mini" type="danger" @click="deleteStaff(scope.row)" >{{ $t('table.delete') }}</el-button>
            </template>
          </el-table-column>
          <!-- <el-table-column :label="$t('table.MonthlyDiscount')" align="center" width="100px">
            <template slot-scope="scope">
              <span v-if="scope.row.FieldInfo.MonthlyDiscount">{{ scope.row.FieldInfo.MonthlyDiscount }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column> -->
          <!-- <el-table-column :label="$t('table.UpdateTime')" align="center" width="200px">
            <template slot-scope="scope">
              <span>{{ scope.row.FieldInfo.UpdateTime || scope.row.FieldInfo.AddTime }}</span>
            </template>
          </el-table-column> -->
          <!-- <el-table-column :label="$t('table.actions')" align="center" width="250px" class-name="small-padding fixed-width">
            <template slot-scope="scope">
              <el-button v-if="calcPermission(permition, 1)" type="primary" @click="addField(scope.row)">{{ $t('table.edit') }}</el-button>
              <el-button v-if="calcPermission(permition, 2)" type="primary" @click="staff(scope.row)">{{ $t('table.qrystaff') }}</el-button>
            </template>
          </el-table-column> -->
        </el-table>
        <div class="pagination-container">
          <el-pagination v-show="total>0" :current-page="listQuery.pageIndex" :page-sizes="[10,20,50,100]" :page-size="listQuery.pageSize" :total="total" background layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange"/>
        </div>
        <div v-show="false">{{ lists }}</div>
      </div>
    </transition>
  </div>
</template>
<script>
import { qryStaff, delFieldUser } from '@/api/field'
import { qryRoleInfo } from '@/api/baseModule'
import waves from '@/directive/waves' // 水波纹指令
export default {
  name: 'UserManage',
  directives: {
    waves
  },
  props: {
    id: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      showAdd: false,
      listQuery: {
        pageIndex: 1,
        pageSize: 10
      },
      listLoading: true,
      list: [],
      permition: 0,
      total: null,
      detail: null
    }
  },
  computed: {
    lists: function() {
      this.qryStaff()
      return this.id
    }
  },
  created() {
    if (this.$store.state.roleInfo) {
      this.$store.state.roleInfo.LsList[0].RolePrograms.forEach(item => {
        if (this.$route.path === item.ProgramInfo.PgUrl) {
          this.permition = item.Permition
        }
      })
    } else {
      qryRoleInfo({
        rId: this.$store.getters.roles.RoleId
      }).then(response => {
        this.$store.state.roleInfo = response
        response.LsList[0].RolePrograms.forEach(item => {
          if (this.$route.path === item.ProgramInfo.PgUrl) {
            this.permition = item.Permition
          }
        })
      })
    }
  },
  methods: {
    qryStaff() {
      this.listQuery.fieldId = this.id
      qryStaff(this.listQuery).then(request => {
        this.listLoading = false
        this.list = request.LsList
        this.total = request.TotalRows
      })
    },
    handleSizeChange(e) {
      this.listQuery.pageSize = e
      this.qryStaff()
    },
    handleCurrentChange(e) {
      this.listQuery.pageIndex = e
      this.qryStaff()
    },
    handleFilter() {
      this.qryStaff()
    },
    addField(detail) {
      this.detail = detail
      this.showAdd = true
    },
    back() {
      this.$emit('back')
    },
    backList1() {
      this.showAdd = false
    },
    deleteStaff(detail) {
      delFieldUser({ userId: detail.UserId }).then(request => {
        this.$message.success('删除成功')
        this.qryStaff()
      })
    }
  }
}
</script>
<style>
</style>
